import { BlockBlobClient, newPipeline } from '@azure/storage-blob';

const pipeline = newPipeline();

export async function uploadBlob(file: File, sas: string, metadata?: Record<string, string>) {
	const client = new BlockBlobClient(sas, pipeline);
	await client.uploadData(await file.arrayBuffer(), {
		metadata,
		blobHTTPHeaders: { blobContentType: file.type }
	});

	return client.url.split('?')[0];
}
